import React, { useState } from 'react'
import '../css/MasterPage.css'
import LeafStorm from '../components/LeafStorm';
import Hamburger from '../components/Hamburger';
import Menu from '../components/Menu';

export default function Bio({ setActivePage }) {
    const [open, setOpen] = useState(false);

    return (
        <div className='pageContainer'>
            <LeafStorm active={open} />
            <div className='navBar'>
                <a className='anchor'>🌸</a>
                <Hamburger open={open} setOpen={setOpen} />
                {open && <Menu isOpen={open} setActivePage={setActivePage} />}
            </div>
            <div className='phantomMenuContainer' />
            <div className='pageContent'>
                <p className='header'>More About Millie</p>
                <div className='contentRow'>
                    <div className='leftContent'>
                        <p className='subHeader'>Software Development</p>
                        <p className='blurb'>I love coding anything that comes to mind. From the simple website or video game
                            to the micro-contorller used to make a goofy circuit come to life. I love it all. I have various
                             fun projects in the works and my most recent one I've been working on is a RFID doormat to scan a
                              chip in my shoe so my door will unlock by me just standing on a welcome mat instead of using my 
                              badge scanner. I love front-end development and I always say I prefer making boxes on the internet look pretty.
                        </p>
                    </div>
                    <div className='rightContent'>
                        <img src='/SoftwareExample.PNG' alt='software pic?' className='bioPic'/>
                    </div>
                </div>
                <div className='contentRow'>
                    <div className='leftContentAlt'>
                        <img src='/MacMini.jpg' alt='tech pics' className='bioPic'/>
                    </div>
                    <div className='rightContentAlt'>
                        <p className='subHeader'>Hardware Enthusiast</p>
                        <p className='blurb'>I really enjoy hardware in any form. I love mechanical keyboards and I have a bunch
                             of wild ones. At work I use a 70% split keyboard which consists of all of the standard number and QWERY
                              keys with some macro keys and the arrows but its split down the middle so I can spread them apart. At home I 
                              use a 60% which is number row and the QWERTY keys. I'm also super into networking gear and have a whole 
                              Ubiquity system in my house for my internet, cameras, and my RFID doorlocks for my exterior doors (a little overkill I will admit). 
                              I also love servers and have a server rack in the data closet in my garage powering a PLEX server and game 
                              servers in addition to other smaller docker containers. I also dislike how the basic mac mini looks so I ended up 
                              pulling all the componenets out of mine and painted it in a cell-shaded style.
                        </p>
                    </div>
                </div>
                <div className='contentRow'>
                    <div className='leftContent'>
                    <p className='subHeader'>Amatuer Mechanic</p>
                    <p className='blurb'>My greenlighting as a mechanic is really only on my two project cars. Back in 2021 I imported a 1993 Honda 
                        ACTY and in 2024 I was able to import my dream car; a 1996 Mini Cooper. They both break constantly and I have lots 
                        to fix every once in a while. The truck is a fun eye catching thing to drive but currently needs some suspension and 
                        drivetrain work before I can start using it again. The mini is unable to charge its own battery at the moment and a new 
                        alternator didn't do the trick so I have more work to get that up and running. The mini will likely recieve a manual 
                        transmission swap in the next year or so but I am trying to decide whether that will be a part of a larger whole engine 
                        swap. I do have to get it drivable first tho...
                    </p>
                    </div>
                    <div className='rightContent'>
                        <img src='/SmoothCars.png' alt='Some Car Pics' className='bioPic'/>
                    </div>
                </div>
                <div className='contentRow'>
                    <div className='leftContentAlt'>
                        <img src='/Snowboard.jpg' alt='Snowboards Pic' className='bioPic'/>
                    </div>
                    <div className='rightContentAlt'>
                        <p className='subHeader'>Snowboarding</p>
                        <p className='blurb'>Winter is my favourite season and I love nothing more than being out in the cold on a mountain with 
                            my board and a good playlist. Living in Utah has given me the opportunity to visit many of the resorts here though I 
                            do have a favourite in Brighton. It has a mix of the best snow, good size, amount of people, and price. The only downside 
                            to Brighton is the drivetime for me. As for Snowboards my favourite brand is Signal Snowboards who are based out of California. 
                            If I'm not working on a weekday during winter there's a solid chance you'll find me up in the mountains having lots of fun!
                        </p>
                    </div>
                </div>
                <div className='contentRow'>
                    <div className='leftContent'>
                        <p className='subHeader'>Pottery</p>
                        <p className='blurb'>Back in middleschool I was introduced to pottery, both handbuilding and wheel throwing, and I have loved 
                            it ever since. In high school I took a pottery class each year and when there were no more levels to the classes I did my 
                            own thing during the 'TA' periods I had. I even went so far as researching and creating my own glazes. The garage I had 
                            built at my house has space in the back I have framed and will eventually get insulated and air conditioned in order to 
                            have my own pottery studio I can work in. Its very theraputic for me and I miss it greatly. Everything takes time and money though.
                        </p>
                    </div>
                    <div className='rightContent'>
                        <img src='Pottery.JPG' alt='pottery image'className='bioPic'/>
                    </div>
                </div>
                <div className='bottomPadding'></div>
            </div>
        </div>
    )
}